import { render } from "./buy-more-drawer.vue?vue&type=template&id=162763c0&ts=true"
import script from "./buy-more-drawer.vue?vue&type=script&lang=ts"
export * from "./buy-more-drawer.vue?vue&type=script&lang=ts"

import "./buy-more-drawer.vue?vue&type=style&index=0&id=162763c0&lang=scss"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__